type JsonObject = Record<string, unknown>;

function asObject(value: unknown): JsonObject | undefined {
  return value !== null && typeof value === 'object'
    ? (value as JsonObject)
    : undefined;
}

function nonEmptyString(value: unknown): string | undefined {
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

/**
 * Extract an access token from both the Core response envelope and legacy
 * unwrapped refresh responses.
 */
export function extractAccessToken(payload: unknown): string | undefined {
  const root = asObject(payload);
  const data = asObject(root?.data);
  const rootTokens = asObject(root?.tokens);
  const dataTokens = asObject(data?.tokens);

  return (
    nonEmptyString(dataTokens?.accessToken) ??
    nonEmptyString(rootTokens?.accessToken) ??
    nonEmptyString(data?.accessToken) ??
    nonEmptyString(root?.accessToken)
  );
}
